import React from "react";
import {
    Modal,
  } from "../../components";


  import ExamUserInterestsForm from './ExamUserInterestsForm';

const ExamUserInterestsModal = ({isVisible, onSubmit, handleChange, getCities, getCourses, telefone, setTelefone, setCurso, setCidade}) => {

    return(
    <Modal isVisible={isVisible}>
        <ExamUserInterestsForm 
            setCurso={setCurso}
            setCidade={setCidade}
            getCourses={getCourses}
            getCities={getCities}
            parentHandleChange={handleChange}
            handleSubmit={onSubmit}
        />
     </Modal>)
}

export default ExamUserInterestsModal